import shuffle from 'hs-lodash/shuffle';
import { CompanySizeOption } from 'signup-constants/signupData/CompanySizeOption';
import { CrmExperienceOption } from 'signup-constants/signupData/CrmExperienceOption';
import { HubInterestOption } from 'signup-constants/signupData/HubInterestOption';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { JobFieldOption } from 'signup-constants/signupData/JobFieldOption';
import { UseCaseOption } from 'signup-constants/signupData/UseCaseOption';
import { isOptionShufflingDisabled } from '../selenium/seleniumFeatures';
import { Data } from './DATA';
export const maybeShuffleOptions = function maybeShuffleOptions(options) {
  return isOptionShufflingDisabled() ? options : shuffle(options);
};
export const DataOptions = {
  [Data.CompanySize]: Object.values(CompanySizeOption),
  [Data.JobField]: [...maybeShuffleOptions([JobFieldOption.Sales, JobFieldOption.Marketing, JobFieldOption.Support, JobFieldOption.Admin]), JobFieldOption.Other],
  [Data.CrmExperienceLevel]: [CrmExperienceOption.None, CrmExperienceOption.HasUsedCrm, CrmExperienceOption.HasUsedHubSpot],
  [Data.HubInterest]: [...maybeShuffleOptions([HubInterestOption.Sales, HubInterestOption.CustomerService, HubInterestOption.Marketing, HubInterestOption.Operations, HubInterestOption.CMS]), HubInterestOption.GeneralOverview],
  [Data.HubletSelection]: [HubletOption.na1, HubletOption.eu1],
  [Data.UseCase]: [...maybeShuffleOptions([UseCaseOption.TrackDeals, UseCaseOption.EmailMarketing, UseCaseOption.ConnectLeads])]
};